<a class="logo"
    [attr.aria-label]="'MENU.LOGO_LABEL' | translate"
    [routerLink]="['/']">
    @if(logoUrl.href.endsWith('.svg')) {
        <app-svg [use]="logoUrl.href"></app-svg>
    } @else {
        <img class="logo-image"
        [use]="logoUrl"
        role="presentation"
        auto="width"
        [srcset]="[ { srcset: mobileLogoUrl, media: '(max-width: 768px)' }, { srcset: logoUrl, media: '(min-width: 769px)' } ]" />
    }
</a>
<a class="call-us" [attr.href]="'tel:'+phone">
    <span class="text">{{ 'MENU.CALL_US' | translate }}</span>
    <span class="number">{{ phone }}</span>
</a>
